/**
 * Snackbar Component - Controller
 * =================================
 */

import type { ITranscludeFunction } from 'angular';
import { hasTranscludedContent } from '../../_base/transclusion';
import { MODE_CLASSES, BASE_CLASSES, DEFAULTS, SnackbarMode } from './constants';

export interface SnackbarBindings {
  mode?: SnackbarMode;
  title?: string;
  text?: string;
  showTitle?: boolean;
  showAction?: boolean;
  actionLabel?: string;
  onActionClick?: (args: { $event: Event }) => void;
}

export class SnackbarController implements SnackbarBindings {
  static $inject = ['$transclude'];

  private $transclude: ITranscludeFunction | null;

  // Bindings
  mode?: SnackbarMode;
  title?: string;
  text?: string;
  showTitle?: boolean;
  showAction?: boolean;
  actionLabel?: string;
  onActionClick?: (args: { $event: Event }) => void;

  // Contenido transcluido reemplaza el binding "text" (mismo patrón que ecButton/ecChip)
  hasContent = false;

  constructor($transclude: ITranscludeFunction) {
    this.$transclude = $transclude;
    this.handleActionClick = this.handleActionClick.bind(this);
  }

  $onInit(): void {
    this.mode = this.mode || DEFAULTS.mode;
    this.actionLabel = this.actionLabel || DEFAULTS.actionLabel;
    if (this.showTitle === undefined || this.showTitle === null) {
      this.showTitle = true;
    }
    if (this.showAction === undefined || this.showAction === null) {
      this.showAction = true;
    }
    this.hasContent = hasTranscludedContent(this.$transclude);
  }

  $onDestroy(): void {
    this.$transclude = null;
  }

  handleActionClick($event: Event): void {
    $event.stopPropagation();
    if (typeof this.onActionClick === 'function') {
      this.onActionClick({ $event });
    }
  }

  private get modeClasses() {
    return MODE_CLASSES[this.mode || DEFAULTS.mode];
  }

  // ---- Clases ----

  getContainerClasses(): string[] {
    return [BASE_CLASSES.container, this.modeClasses.container];
  }

  getContentClasses(): string[] {
    return [BASE_CLASSES.content];
  }

  getTitleClasses(): string[] {
    return [BASE_CLASSES.title, this.modeClasses.title];
  }

  getTextClasses(): string[] {
    return [BASE_CLASSES.text, this.modeClasses.text];
  }

  getActionClasses(): string[] {
    return [BASE_CLASSES.action, this.modeClasses.action];
  }
}

export default SnackbarController;
